import { render, staticRenderFns } from "./ElemUploadList.vue?vue&type=template&id=60d3ce8b&scoped=true"
import script from "./ElemUploadList.vue?vue&type=script&lang=js"
export * from "./ElemUploadList.vue?vue&type=script&lang=js"
import style0 from "./ElemUploadList.vue?vue&type=style&index=0&id=60d3ce8b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d3ce8b",
  null
  
)

export default component.exports